module dg.objects {

    export class ValueObjectDisplayerController extends PropertyDisplayerControllerBase<dg.domain.model.DomainModelRefInfo> {

        //public navLink: restfulApi.Link;

        protected init() {
            //console.log(this.value);
        }
    }

    dg.objects.AngularHelper.registerPropertyDisplayer(ValueObjectDisplayerController, 'valueObjectDisplayer', {
        //templateUrl: '/digmo/src/objects/properties/lookup/reference-displayer.html',
        templateUrl: ($element, $attrs: any, objectService: dg.objects.ObjectService) => {
            let templateType:string = $attrs.templateType;
            let templateUrl = '/digmo/src/objects/properties/lookup/value-object-displayer.html';
            if (!templateType) {
                templateType = 'lookup/value-object-displayer';
            }
            else {

                //templateType = templateType.replace(/([A-Z])/g, (g) => `-${g[0].toLowerCase()}`);
                templateType = templateType.toLowerCase();

                if (objectService.templateExists(templateType)) {
                    templateUrl = `/app/src/templates/value-objects/${templateType}-template.html`;
                }
            }

            return templateUrl;
        }
    });
}